import { render } from "./prosper-footer.vue?vue&type=template&id=331752c6&scoped=true"
import script from "./prosper-footer.vue?vue&type=script&lang=js"
export * from "./prosper-footer.vue?vue&type=script&lang=js"

import "./prosper-footer.vue?vue&type=style&index=0&id=331752c6&scoped=true&lang=css"

import exportComponent from "/home/rof/src/bitbucket.org/AsokoInsight/virtual-dealroom/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331752c6"]])

export default __exports__